import {defineStore} from "pinia";
import { PharmacyInformationRestService } from "@/services/rest/cms-pharmacy/PharmacyInformationRestService";
import { PharmacyRestDto } from "@/api/pharma-cms-pharmacy/models";
import { CustomerContext } from "@/context/CustomerContext";

interface deliveryMethodEnumContent {
    selectedDeliveryTypeCode: string|null;
}

interface State {
    deliveryMethodEnumContent: deliveryMethodEnumContent;
    selectedDeliveryMethodCode: string|null;
    pharmacyInfo: PharmacyRestDto|null;
}

export const usePharmacyStore = defineStore("PharmacyStore", {
    state: (): State => {
        return {
            deliveryMethodEnumContent: {
                selectedDeliveryTypeCode: null,
            },
            selectedDeliveryMethodCode: null,
            pharmacyInfo: null,
        }
    },
    actions: {
        async initialize(): Promise<void> {
            await this.fetchPharmacyInfo();
        },
        async fetchPharmacyInfo(): Promise<void> {
            this.pharmacyInfo = await PharmacyInformationRestService.getInstance()
                .getPharmacy(CustomerContext.getPharmacyCode());
        }
    },
    getters: {},
});
